import style from './TableSelect.module.css'
import { ArrowSelect } from '../../UI/ArrowSelect/ArrowSelect'
import { useDispatch, useSelector } from 'react-redux'
import { setActiveTag } from '../../Redux/Slices/Cables'
import SearchSelect from '../Search/SearchSelects'
import { useRef, useState, useEffect } from 'react'
import { closeAllSelect, openOrClose } from '../../Redux/Slices/Select/Select'


export function TableSelect({options = [], value}) {
    const dispatch = useDispatch()
    const [selectOptions, setSelectOptions] = useState(options)
    const isOpen = useSelector((state) => state.select.TableSelect)
    const ref = useRef(null)

    useEffect(() => {
        setSelectOptions(options)
    },[options])

    const setIsOpen = () => {
        dispatch(openOrClose('TableSelect'))
        isOpen && dispatch(closeAllSelect())
    }
  
    return <div className={style.table___container}>
        <div className={`${style.table__value} select`} onClick={setIsOpen}> <span style={{color: value.id ? 'white' : '#7e8279'}}>{value.name ? value.name : 'Не выбрано'} </span>  <ArrowSelect /> </div> 
        <div ref={ref} className={`${style.table__list} ${isOpen ? style.active : ''} overlay`} style={{maxHeight: `calc(100vh - ${ref?.current?.getBoundingClientRect()?.top}px - 10px)`}}>
            <div className={style.modal__container}>
                <SearchSelect setSelectOptions={setSelectOptions} options={options} />
                <div className={style.scrollContainer}>
                    <div className={style.table__list_item} onClick={() => {
                            dispatch(setActiveTag({name: 'Не выбрано', id: null}))
                            setIsOpen()
                            dispatch(closeAllSelect())
                        }}>Не выбрано</div>
                    {selectOptions.map((item, index) => {
                        return <div key={index} className={`${style.table__list_item} ${value.id === item.id ? style.active_item : ''}`} onClick={() => {
                            if(value.id !== item.id) {
                                dispatch(setActiveTag(item))
                                console.log(item);
                            }
                            setIsOpen(false)
                        }}>{item.name}</div>
                    })}
                </div>
            </div>
        </div>
    </div>
}